import { Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fade, FormControlLabel, TextField } from "@material-ui/core";
import React, { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { IConvectionSection } from "../../interfaces/IConvectionSection";
import { RootState } from "../../reducers/rootReducer";
import { checkConvectionsectionName } from "../../services/convectionsectionServices";
import { addConvectionSection, updateConvectionSectionSignature } from "../../slices/convectionSectionSlice";
import { prepareConvectionSection } from "../../utilities/loadConvectionSection";
import FurnaceSelector from "../common/FurnaceSelector";
import { AuthContextProps, withAuth } from "react-oidc-context";
import { getToken } from "../../utilities/helperFunctions";
interface IAddConvectionSectionProps {
    convectionsection: IConvectionSection;

}

interface OIDCAuth {
    auth?: AuthContextProps
}

const mapStateToProps = (state: RootState) => {
    return {
        currentConvectionSectionId: state.convectionsection.current_convectionsection_id,
        current_furnace_id: state.furnace.current_furnace_id,
        current_asset_name: state.furnace.current_asset_name,
        convectionsections: state.convectionsection.convectionsections
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addConvectionSection: (newConvectionSection: IConvectionSection) => dispatch(addConvectionSection(newConvectionSection)),
        updateSignature: (convectionSection_id: string) => dispatch(updateConvectionSectionSignature({ convectionSection_id })),
    };
};
const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type IAddConvectionSectionReduxProps = PropsFromRedux & IAddConvectionSectionProps & OIDCAuth;

type IAddConvectionSectionState = {
    showDialog: boolean;
    name: string;
    is_public: boolean;
    isNameAvailable: boolean;
    nameErrorMessage: string;
    showLoading: boolean;
}
class AddConvectionSection extends Component<IAddConvectionSectionReduxProps, IAddConvectionSectionState>{

    constructor(props) {
        super(props);

        this.state = {
            showDialog: false,
            name: "",
            is_public: true,
            isNameAvailable: false,
            nameErrorMessage: "",
            showLoading: false,
        }
    }

    toggleShowDialog() {
        this.setState({
            showDialog: !this.state.showDialog,
            name: "",
            isNameAvailable: false,
            nameErrorMessage: ""
        })
    }

    handleNameInput(event) {
        this.setState({
            name: event.target.value.toUpperCase()
        })
    }

    addNewConvectionSection = async () => {
        const accessToken = await getToken(this.props.auth);
        if (!!this.state.name?.trim()) {

            this.setState({
                showLoading: true,
            })
            let setName = this.state.is_public === true ? this.state.name.trim() + "(PUBLIC)" : this.state.name.trim();
            let newConvectionSection = await prepareConvectionSection(setName, this.props.current_furnace_id, this.props.current_asset_name, accessToken)
            newConvectionSection.is_public = this.state.is_public;
            try {
                let isNameInRedux = this.props.convectionsections.some(convectionsection => convectionsection.name === newConvectionSection.name);

                if (isNameInRedux) {
                    this.setState({
                        isNameAvailable: true,
                        nameErrorMessage: "Name already exist!",
                        showLoading: false,
                    })
                } else {
                    let isNameAvailable = await checkConvectionsectionName(newConvectionSection, accessToken);
                    if (isNameAvailable.status) {
                        this.setState({
                            isNameAvailable: true,
                            nameErrorMessage: !!isNameAvailable.message ? isNameAvailable.message : "Name already exist!",
                            showLoading: false,
                        })
                    } else {
                        this.props.addConvectionSection(newConvectionSection);
                        this.props.updateSignature(newConvectionSection.id);
                        this.toggleShowDialog();
                        this.setState({
                            showLoading: false,
                        })
                    }
                }
            } catch (error) {
                // Api error hendaling 
                this.setState({
                    isNameAvailable: true,
                    showLoading: false,
                    nameErrorMessage: "Oops somthing went to wrong!"
                })
            }
        } else {
            this.setState({
                isNameAvailable: true,
                nameErrorMessage: "Please enter a name!",
                showLoading: false,
            })
        }


    }

    handleChangeIsPublic(event) {
        this.setState({
            is_public: !this.state.is_public
        })
    }

    render() {
        return (
            <div className="control-header element">
                <button
                    className="button"
                    onClick={() => this.toggleShowDialog()}
                    disabled={this.props.convectionsection !== undefined && !this.props.convectionsection.is_saved}
                >
                    Add
                </button>
                <Dialog open={this.state.showDialog} onClose={() => this.toggleShowDialog()} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Add new convection section</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            To add a new convection section, please provide the following information:
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Name"
                            type="text"
                            fullWidth
                            defaultValue={this.state.name}
                            value={this.state.name}
                            onChange={(event) => this.handleNameInput(event)}
                            helperText={this.state.nameErrorMessage}
                            error={this.state.isNameAvailable}
                        />
                        <FurnaceSelector disabled={false} />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.is_public}
                                    onChange={(event) => this.handleChangeIsPublic(event)}
                                    name=""
                                    value={this.state.is_public}
                                    color="primary"
                                />
                            }
                            label="Is Public?"
                        />
                    </DialogContent>
                    <DialogActions>
                        <button className="button" onClick={() => this.toggleShowDialog()} >
                            Cancel
                        </button>
                        <button className="button" onClick={() => this.addNewConvectionSection()} disabled={this.state.showLoading}>
                            Add {this.state.showLoading === true && (
                                <Fade
                                    in={this.state.showLoading}
                                    style={{
                                        transitionDelay: this.state.showLoading ? '800ms' : '0ms',
                                    }}
                                    unmountOnExit
                                >
                                    <CircularProgress size={11} />
                                </Fade>
                            )}
                        </button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

};

export default withAuth(connector(AddConvectionSection));